import { render, staticRenderFns } from "./EditCampaign.vue?vue&type=template&id=25f297b5&"
import script from "./EditCampaign.vue?vue&type=script&lang=ts&"
export * from "./EditCampaign.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports